// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1sJaF","item":"PaymentsMobile_item__3u-63","label":"PaymentsMobile_label__VShMK","amount":"PaymentsMobile_amount__Y4poV"};